import { useEffect, useState } from "react";
import { Fade, LMask } from "./Reveal";
import { ARROW_UR } from "./Bits";
import { EMAIL, GITHUB_URL, LINKEDIN_URL, RESUME_URL } from "../data";

export function Hero() {
  const [sideVisible, setSideVisible] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setSideVisible(true), 200);
    return () => clearTimeout(id);
  }, []);

  return (
    <section className="hero" id="home">
      <Fade className="hero-kick">Software Engineer, CS @ University of Toronto</Fade>
      <h1>
        <LMask className="row">NEHAN</LMask>
        <LMask className="row">
          PUN<em>j</em>ani
        </LMask>
      </h1>
      <div className="hero-tag">
        <Fade className="big-serif">
          I do stuff with <span style={{ color: "var(--verm)" }}>code.</span>
        </Fade>
      </div>
      <Fade className="hero-bottom">
        <div className="hero-cta">
          <a className="ed-btn solid" href={RESUME_URL} target="_blank" rel="noreferrer">
            View Résumé <span className="a">{ARROW_UR}</span>
          </a>
          <a className="ed-btn" href={`mailto:${EMAIL}`}>
            Email
          </a>
          <a className="ed-btn" href={GITHUB_URL} target="_blank" rel="noreferrer">
            GitHub <span className="a">{ARROW_UR}</span>
          </a>
          <a className="ed-btn" href={LINKEDIN_URL} target="_blank" rel="noreferrer">
            LinkedIn <span className="a">{ARROW_UR}</span>
          </a>
        </div>
        <div className="meta">
          Based in Toronto / Montreal
          <br />
          Currently @ C3G
          <br />
          <span className="live">
            <span className="pulse"></span>Open to internships
          </span>
        </div>
      </Fade>
      <div className="scroll-cue">
        Scroll <span className="ln"></span>
      </div>
      <div className={`hero-side${sideVisible ? " visible" : ""}`} aria-hidden="true">
        <span className="hs-label">Software Engineer</span>
        <span className="hs-line"></span>
        <span className="hs-ghost">2026</span>
        <span className="hs-line"></span>
      </div>
    </section>
  );
}
